import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';
import SqlSidebar from './components/SqlSidebar';
import ObjectTabs from './components/ObjectTabs';
 import image401 from '../../images/401.png';
import './css/SqlHome.css';

const SqlHome = () => {
  const [dbObjects, setDbObjects] = useState([]);
  const [selectedType, setSelectedType] = useState('Table');
  const [selectedObject, setSelectedObject] = useState(null);
  const [activeTab, setActiveTab] = useState('sql');
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  const token = getToken();
  const authHeader = {
    headers: { Authorization: token ? `Bearer ${token}` : '' },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [permRes, dbRes] = await Promise.all([
          axios.get(`${API_URL}/${ENDPOINTS.SYS}/getlink/ktc-sql`, authHeader),
          axios.get(`${API_URL}/${ENDPOINTS.SQL}/get-db-objects`, authHeader),
        ]);

        setPermissions(permRes.data?.permissions);
        setDbObjects(dbRes.data || []);
      } catch (error) {
        console.error('Error fetching system data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (
    !loading &&
    permissions?.can_view !== 1 &&
    permissions?.can_view !== true
  ) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: `url(${image401})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
        }}
      />
    );
  }

  const handleSelectObject = (obj) => {
    setSelectedObject(obj);
    setActiveTab('browse');
  };

  const handleTabChange = (tab) => {
    if (tab === 'db_updates') {
      if (
        window.confirm(
          'Are you sure to update Database with last version of Node Updates?'
        )
      ) {
        setActiveTab(tab);
      }
    } else {
      setActiveTab(tab);
    }
  };

  return (
    <>
      <style>{`
        .pma-top-header {
          background-color: #23272d;
          color: #dcdcdc;
          font-family: sans-serif;
          font-size: 13px;
          border-bottom: 2px solid #e0e0e0;
        }
        .pma-nav-tabs {
          border-bottom: 1px solid #ccc;
          display: flex;
          gap: 4px;
          padding-left: 0;
          margin-bottom: 12px;
          list-style: none;
        }
        .pma-nav-tabs .nav-link {
          background-color: #e8e8e8;
          color: #333;
          border: 1px solid #aaa;
          border-bottom: none;
          border-radius: 3px 3px 0 0;
          padding: 6px 14px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }
        .pma-nav-tabs .nav-link:hover:not(:disabled) {
          background-color: #f5f5f5;
        }
        .pma-nav-tabs .nav-link.active {
          background-color: #ffffff;
          border-color: #aaa #aaa #ffffff #aaa;
          color: #000;
          font-weight: bold;
        }
        .pma-nav-tabs .nav-link:disabled {
          color: #888;
          background-color: #e0e0e0;
          cursor: not-allowed;
          opacity: 0.6;
        }
        .pma-breadcrumb-bar {
          background: #f8f9fa;
          border: 1px solid #dcdcdc;
          border-radius: 3px;
          padding: 6px 10px;
          font-size: 12px;
          color: #555;
          margin-bottom: 10px;
        }
      `}</style>

      <div
        className="pma-container d-flex flex-column h-100"
        style={{ background: '#f3f3f3', minHeight: '100vh' }}
      >
        <header className="pma-top-header p-2 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <strong style={{ color: '#ffffff', fontSize: '15px' }}>
              phpMyAdmin
            </strong>
            <span className="badge bg-secondary" style={{ fontSize: '10px' }}>
              mini
            </span>
          </div>
          <div className="small">
            Server: <strong>127.0.0.1</strong> | Database:{' '}
            <strong>KTC Framework</strong>
          </div>
        </header>

        <div className="d-flex flex-grow-1">
          <aside
            className="pma-sidebar bg-light border-end p-2"
            style={{ width: '240px', minWidth: '240px', overflowY: 'auto' }}
          >
            <div
              className="pma-sidebar-header pb-2 mb-2 border-bottom fw-bold text-secondary"
              style={{ fontSize: '13px' }}
            >
              Navigation
            </div>
            <SqlSidebar
              dbObjects={dbObjects}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
              setSelectedObject={handleSelectObject}
            />
          </aside>

          <main className="pma-main-content flex-grow-1 p-3" style={{ minWidth: 0, overflowX: 'hidden' }}>
  <div className="pma-breadcrumb-bar">
    Server: <strong>localhost</strong>
    {selectedObject && (
      <>
        {' » '}
        Database: <strong>main</strong>
        {' » '}
        Table:{' '}
        <strong>{selectedObject.name || selectedObject}</strong>
      </>
    )}
  </div>

  {/* Main Action Tabs */}
  {/* Main Action Tabs */}
            <ul className="pma-nav-tabs">
              <li>
                <button
                  className={`nav-link ${activeTab === 'browse' ? 'active' : ''}`}
                  onClick={() => handleTabChange('browse')}
                  disabled={!selectedObject}
                >
                  Browse
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${activeTab === 'structure' ? 'active' : ''}`}
                  onClick={() => handleTabChange('structure')}
                  disabled={!selectedObject}
                >
                  Structure
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${activeTab === 'sql' ? 'active' : ''}`}
                  onClick={() => handleTabChange('sql')}
                >
                  SQL
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${activeTab === 'db_updates' ? 'active' : ''}`}
                  onClick={() => handleTabChange('db_updates')}
                >
                  DB Updates
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${activeTab === 'search' ? 'active' : ''}`}
                  onClick={() => handleTabChange('search')}
                  disabled={!selectedObject}
                >
                  Search
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${activeTab === 'insert' ? 'active' : ''}`}
                  onClick={() => handleTabChange('insert')}
                  disabled={!selectedObject}
                >
                  Insert
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${activeTab === 'export' ? 'active' : ''}`}
                  onClick={() => handleTabChange('export')}
                >
                  Export
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${activeTab === 'import' ? 'active' : ''}`}
                  onClick={() => handleTabChange('import')}
                >
                  Import
                </button>
              </li>
                <li>
                <button
                  className={`nav-link ${activeTab === 'import-csv-data' ? 'active' : ''}`}
                  onClick={() => handleTabChange('import-csv-data')}
                >
                  Import CSV
                </button>
              </li>
            </ul>

  <div className="pma-tab-content bg-white p-3 border rounded shadow-sm" style={{ minWidth: 0, overflowX: 'auto' }}>
    <ObjectTabs
      selectedObject={selectedObject}
      activeTab={activeTab}
    />
  </div>
</main>
        </div>
      </div>
    </>
  );
};

export default SqlHome;
